export default "https://cdn-web.disco.co/slack-validate-connection-mobile-1-fe1dd680c6e438dc730a937577162603.png";